module.exports = __webpack_public_path__ + "static/petkovic-profile-886f381685cc635c535061c5bc9e2c82.jpg";